import React, { useContext } from 'react';
import { Clickable } from 'src/components/clickable';
import { UserAvatar } from 'src/components/user-avatar';
import { AppContext } from 'src/components/app-context';
import * as S from './styles';

type Props = {
  avatar: string;
  className?: string;
  displayName: string;
  link?: string | null;
  size: number;
  hideExpertIcon?: boolean;
};

const ExpertAvatar = ({
  avatar,
  className,
  displayName,
  link,
  size,
  hideExpertIcon,
}: Props) => {
  const { renderMode, linkTo } = useContext(AppContext);

  const children = (
    <>
      <UserAvatar size={size} avatar={avatar} displayName={displayName} />
      {!hideExpertIcon && <S.ExpertIcon size={size / 3} />}
    </>
  );

  return (
    <S.ExpertAvatar className={className}>
      {link ? (
        <Clickable
          to={linkTo(
            'expertProfile',
            { semantic_id: link || '' },
            renderMode === 'native' ? { view: 'native' } : undefined
          )}
        >
          {children}
        </Clickable>
      ) : (
        children
      )}
    </S.ExpertAvatar>
  );
};

export default ExpertAvatar;
